module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei1.svg";